import {
  Container,
  LoadingBar,
  LoadingBarContainer,
  LoadingContainer,
  LoadingLabelContainer,
  StyledLabel,
} from './style'

const Loading: React.FC<{ progress: number }> = ({ progress }) => {
  return (
    <Container>
      <LoadingContainer>
        <LoadingBarContainer>
          <LoadingBar style={{ width: `${progress}%` }} />
        </LoadingBarContainer>
      </LoadingContainer>
      <LoadingLabelContainer>
        <StyledLabel>{progress}%</StyledLabel>
      </LoadingLabelContainer>
    </Container>
  )
}

export default Loading
